import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'round',
    standalone: false
})
export class RoundPipe implements PipeTransform {
  transform(value: number, decimalPlaces: number = 3): number {
    if (isNaN(value)) return value;
    return parseFloat(value.toFixed(decimalPlaces));
  }
}
